import { KYMW0900Model } from "../kymw0900.model";
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { GetGroupingInfoRequestModel } from '../vo/kymw0900-get-grouping-info-request.model';

/**
 * グルーピング情報取得処理サービス
 *
 * @export GetGroupingInfoService
 * @class GetGroupingInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetGroupingInfoService extends PlessJsonResponderSub<any> {

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetGroupingInfoService
   */
  private successFunc: Function;

  model: KYMW0900Model;
  vo: GetGroupingInfoRequestModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetGroupingInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        PCodeCommon: {
          condition: {
            OrderCode: this.vo.orderCode,
            PCode: this.vo.pCode,
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetGroupingInfoService
   */
  execute(model: any, vo: GetGroupingInfoRequestModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('getGroupingInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetGroupingInfoService
   */
  success(data: any): void {
    if (data !== null) {
      this.model.setGroupingInfo(data);
      if (this.successFunc) {
        this.successFunc(data);
      }
    }
  }
}
